require("core-js/modules/es.array.flat.js");

require("core-js/modules/es.array.unscopables.flat.js");

var _objectWithoutProperties = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

module.exports = function (e) {
  var t = {};

  function r(o) {
    if (t[o]) return t[o].exports;
    var n = t[o] = {
      i: o,
      l: !1,
      exports: {}
    };
    return e[o].call(n.exports, n, n.exports, r), n.l = !0, n.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, o) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: o
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var o = Object.create(null);
    if (r.r(o), Object.defineProperty(o, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var n in e) {
      r.d(o, n, function (t) {
        return e[t];
      }.bind(null, n));
    }
    return o;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 41);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  3: function _(e, t) {
    e.exports = require("../../styles");
  },
  41: function _(e, t, r) {
    "use strict";

    var o = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    },
        n = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var r in e) {
        Object.hasOwnProperty.call(e, r) && (t[r] = e[r]);
      }
      return t.default = e, t;
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var a = o(r(1)),
        l = n(r(2)),
        i = r(3),
        d = o(r(42)),
        s = i.colorPalettes.KineduPalette,
        u = {
      primary: {
        main: s.cognitive,
        alt: "white"
      },
      secondary: {
        main: s.kinedu,
        alt: "white"
      },
      default: {
        main: s.shadeLighter,
        alt: s.shadeDark
      },
      disabled: {
        main: s.shadeMediumDark,
        alt: "white"
      },
      undefined: {
        main: "black",
        alt: "transparent"
      }
    },
        c = function c(e) {
      switch (e) {
        case "primary":
          return u.primary;

        case "secondary":
          return u.secondary;

        case "default":
          return u.default;

        case "disabled":
          return u.disabled;

        default:
          return {
            main: e,
            alt: "white"
          };
      }
    },
        f = l.default.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  min-height: 50px;\n\n  margin: 0;\n  padding: 10px 20px;\n  color: ", ";\n  background-color: transparent;\n  border: none;\n  border-radius: 4px;\n\n  font-size: 14px;\n  font-weight: bold;\n  text-transform: unset;\n  outline: none;\n\n  cursor: pointer;\n\n  position: relative;\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n", "\n"])), function (_ref) {
      var e = _ref.color;
      return c(e).main;
    }, function (_ref2) {
      var e = _ref2.fill;
      return e ? l.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 100%;\n  "]))) : "";
    }, function (_ref3) {
      var e = _ref3.small;
      return e ? l.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    min-height: 40px;\n  "]))) : "";
    }, function (_ref4) {
      var e = _ref4.maxWidth;
      return e && ("number" == typeof e ? "max-width: ".concat(e, "px;") : "max-width: ".concat(e, ";"));
    }, function (_ref5) {
      var e = _ref5.outline;
      return e && l.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: transparent;\n    border: ", ";\n  "])), function (_ref6) {
        var e = _ref6.color;
        return c(e).main;
      }, function (_ref7) {
        var e = _ref7.color;
        return "1px solid " + c(e).main;
      });
    }, function (_ref8) {
      var e = _ref8.flat;
      return e && l.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    color: ", ";\n    background-color: ", ";\n  "])), function (_ref9) {
        var e = _ref9.color;
        return c(e).alt;
      }, function (_ref10) {
        var e = _ref10.color;
        return c(e).main;
      });
    }, function (_ref11) {
      var e = _ref11.rounded;
      return e && l.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    border-radius: 100px;\n  "])));
    }, function (_ref12) {
      var e = _ref12.disabled,
          t = _ref12.flat,
          r = _ref12.outline;
      return e ? t ? l.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n          color: ", ";\n          background-color: ", ";\n          border: none;\n          cursor: not-allowed;\n        "])), u.disabled.alt, u.disabled.main) : r ? l.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          color: ", ";\n          background-color: transparent;\n          border: 1px solid ", ";\n          cursor: not-allowed;\n        "])), u.disabled.main, u.disabled.main) : l.css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n        color: ", ";\n        background-color: transparent;\n        cursor: not-allowed;\n      "])), u.disabled.main) : "";
    }, function (_ref13) {
      var e = _ref13.shadow;
      return e && l.css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  box-shadow: 0px 4px 30px -12px ", ";\n"])), s.shadeDark);
    });

    t.default = function (_ref14) {
      var e = _ref14.children,
          t = _ref14.className,
          r = _ref14.color,
          o = _ref14.disabled,
          n = _ref14.flat,
          l = _ref14.onClick,
          i = _ref14.outline,
          s = _ref14.rounded,
          u = _ref14.fill,
          c = _ref14.small,
          p = _ref14.shadow,
          b = _ref14.maxWidth,
          m = _ref14.style,
          h = _ref14.loading,
          x = _objectWithoutProperties(_ref14, ["children", "className", "color", "disabled", "flat", "onClick", "outline", "rounded", "fill", "small", "shadow", "maxWidth", "style", "loading"]);

      return a.default.createElement(f, Object.assign({
        type: "button",
        "data-testid": "lego-styled-button",
        className: "lego-button " + t,
        color: r,
        disabled: o,
        flat: n,
        onClick: l,
        outline: i,
        rounded: s,
        maxWidth: b,
        fill: u ? 1 : 0,
        small: c ? 1 : 0,
        shadow: p,
        style: m
      }, x), h ? a.default.createElement(d.default, {
        loading: !0,
        name: "threedots",
        position: "relative",
        color: "white",
        bgColor: "transparent"
      }) : e);
    };
  },
  42: function _(e, t) {
    e.exports = require("../Spinner/Spinner");
  }
});